export default __webpack_public_path__ + "static/media/vans-brand.a3635e73.png";